import * as React from 'react';

// @ts-ignore
import Group from 'entities/Group';
import PendingMembershipsButtonContainer from 'groupMembershipRequests/containers/PendingMembershipsButtonContainer';
import PendingMembershipsTableContainer from 'groupMembershipRequests/containers/PendingMembershipsTableContainer';
import PendingMembershipsList from 'groupMembershipRequests/components/PendingMembershipsList';

import './PendingMemberships.scss';

type Props = {
  group: Group;
};

class PendingMemberships extends React.Component<Props> {
  render() {
    const { group } = this.props;
    return (
      <PendingMembershipsList groupUuid={group.getUuid()} groupCode={group.getCodeOrError()} />
    );
  }
}

export {
  PendingMembershipsButtonContainer as PendingMembershipsButton,
  PendingMembershipsTableContainer as PendingMembershipsTable,
  PendingMemberships,
};

export default PendingMemberships;
